/**
 * @desc  ProximityCardService class.
 * @ngInject
 */
export default class ProximityCardService {
  /**
   * Constructor of the class.
   * @param {$rootScope} $rootScope
   * @param {$q} $q
   * @param {$log}  $log
   * @param {$http} $http
   */
  constructor(
    $q, $log, $http, $rootScope
  ) {
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.$log = $log;
    this.$http = $http;
  }

  getProximityCardStudents(cardId) {
    return this.$http({
      method: 'GET',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/proximity-card/${cardId}/ownerCardList`
    }).then(result => {
      return this.$q.resolve(result.data);
    }, error => this.$q.reject(error));
  }
}
